
















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import alegacionModule from "@/store/modules/alegacion-module";
import alegaciones_loteModule from "@/store/modules/alegaciones_lote-module";
import usuarioModule from "@/store/modules/usuario-module";
import { alegacion_historico } from "@/shared/dtos/alegacion_historico";
import { alegaciones_lote } from "@/shared/dtos/alegaciones_lote";
import { RouterNames } from "@/router/routernames";

@Component
export default class AlegacionesLoteVisor extends Vue {
  @Prop({ required: true, type: Number }) idLote!: number;

  public cargando: boolean = false;
  public error: string | null = null;
  public loteInfo: alegaciones_lote | null = null;

  public get alegaciones_historico(): alegacion_historico[] {
    return alegacionModule.alegaciones_historico;
  }

  public async mounted() {
    await usuarioModule.getusuarios();
    this.cargarAlegaciones();
  }

  @Watch("idLote")
  public onIdLoteChange() {
    this.cargarAlegaciones();
  }

  public async cargarAlegaciones() {
    this.cargando = true;
    this.error = null;

    try {
      await Promise.all([
        alegacionModule.getAlegacionesByLote(this.idLote),
        alegaciones_loteModule.getLote(this.idLote),
      ]);
      this.loteInfo = alegaciones_loteModule.lote;
    } catch (e) {
      this.error =
        e.message || "No se pudieron cargar las alegaciones del lote.";
      console.error("Error cargando alegaciones:", e);
    } finally {
      this.cargando = false;
    }
  }

  public getEstadoColor(estado: string | null): string {
    if (!estado) return "grey";
    switch (estado.toUpperCase()) {
      case "ACEPTADA":
        return "success";
      case "DISCREPANCIA":
        return "warning";
      case "PENDIENTE":
        return "info";
      default:
        return "grey";
    }
  }

  public getEstadoLoteColor(estado: string): string {
    switch (estado.toUpperCase()) {
      case "ACEPTADA":
        return "success";
      case "DISCREPANCIA":
        return "error";
      case "PARCIAL":
        return "warning";
      case "PENDIENTE":
        return "info";
      default:
        return "grey";
    }
  }

  public obtenerNombreUsuario(id: number): string {
    const usuario = usuarioModule.usuarios.find((u) => u.id === id);
    return usuario ? usuario.nombre : "Usuario desconocido";
  }

  public navegarAFichaje() {
    if (this.loteInfo && this.loteInfo.id_fichaje_fk) {
      this.$router.push({
        name: RouterNames.FichaFichajeFormulario,
        params: { id: this.loteInfo.id_fichaje_fk.toString() },
      });
    }
  }

  public formatearFecha(fecha: string | Date): string {
    if (!fecha) return "N/A";
    const dateObj = new Date(fecha);
    return (
      dateObj.toLocaleDateString("es-ES") +
      " " +
      dateObj.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  }

  public async sendEmailByIdLote(id: number) {
    await alegaciones_loteModule.sendEmailByIdLote(id);
  }
}
